/**
 * Normalizes a custom field value by converting whitespace-only strings to null
 * @param value - The custom field value to normalize
 * @returns The normalized value (null if whitespace-only string, otherwise original value)
 */
export function normalizeCustomField(value: any): any {
    if (typeof value === 'string' && value.trim() === '') {
        return null;
    }
    return value;
}
